import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinravet() {



const cardData = {
  keyword: " Cab Service in Ravet ",
"headingDescription": "SRS Cab Service offers Cab Service in Ravet tailored for comfortable, reliable, and on-time travel for residents, students, and working professionals. Whether you need daily commuting, airport transfers, office travel, or outstation cab services, our well-maintained fleet and courteous drivers ensure a smooth journey every time. With simple booking, competitive pricing, and round-the-clock customer support, SRS Cab Service makes travel in Ravet convenient, efficient, and completely hassle-free.",
"topPlaces": [
  {
    "title": "Sentosa Water Park",
    "description": "Sentosa Water Park is a popular entertainment destination in Ravet, perfect for family outings and fun activities. Travelers using Cab Service in Ravet from SRS Cab Service often visit for relaxation and enjoyment."
  },
  {
    "title": "Symbiosis Skills and Professional University",
    "description": "This well-known university in Ravet attracts students and visitors. Customers using SRS Cab Service frequently travel here for academic and campus-related visits."
  },
  {
    "title": "Durga Tekdi",
    "description": "Durga Tekdi is a scenic hill area known for its greenery and peaceful environment. Travelers using SRS Cab Service often visit for morning walks and relaxation."
  },
  {
    "title": "Appu Ghar Amusement Park",
    "description": "Appu Ghar offers rides and entertainment for families and children. Visitors using SRS Cab Service often include this destination for fun and leisure."
  },
  {
    "title": "Bhakti Shakti Garden",
    "description": "Bhakti Shakti Garden is a well-maintained park ideal for relaxation and family outings. Travelers using SRS Cab Service enjoy its greenery and calm ambiance."
  },
  {
    "title": "Akkalkot Swami Samarth Mandir",
    "description": "Akkalkot Swami Samarth Mandir is a spiritual place attracting devotees. Visitors using SRS Cab Service often visit for blessings and peaceful experiences."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "This science park is an educational and entertaining destination for families. Travelers using SRS Cab Service often include it in their plans."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports and recreational activities. Visitors using SRS Cab Service often visit for events and fitness purposes."
  },
  {
    "title": "Kasarwadi Market",
    "description": "Kasarwadi Market is a busy shopping hub with local stores and eateries. Travelers using SRS Cab Service often explore this area for shopping and food."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "Rajiv Gandhi Infotech Park is a major IT hub near Ravet. Business travelers using SRS Cab Service frequently commute here for work."
  }
],



services: [
{
name: "Cab Service in Ravet",
description: "Cab service in Ravet offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Ravet Cab Service",
description: "Ravet cab service provides dependable travel for city and intercity routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Ravet",
description: "Taxi service in Ravet offers convenient transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Ravet Taxi Service",
description: "Ravet taxi service provides reliable transportation for local and long-distance travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Ravet",
description: "Cab booking Ravet provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Ravet",
description: "Taxi booking Ravet offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Ravet",
description: "Cab near Ravet helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Ravet",
description: "Taxi near Ravet offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Ravet",
description: "Best cab service in Ravet provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Ravet",
description: "Cheap cab service Ravet offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Ravet",
description: "Affordable cab service Ravet provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Ravet Cab Hire",
description: "Ravet cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Ravet Taxi Hire",
description: "Ravet taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Ravet Cab for Airport",
description: "Ravet cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Ravet Airport Cab Service",
description: "Ravet airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Ravet Cab for Outstation",
description: "Ravet cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Ravet Pune",
description: "Cab service Ravet Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Ravet Pune",
description: "Taxi service Ravet Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Ravet Pune",
description: "Cab booking Ravet Pune provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab on Rent in Ravet",
description: "Innova cab on rent in Ravet offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab Ravet",
description: "Innova Crysta cab Ravet provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Ravet",
description: "Ertiga cab Ravet offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab Ravet",
description: "Dzire cab Ravet provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab on Rent Ravet",
description: "Sedan cab on rent Ravet offers budget-friendly travel for daily and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Luxury Cab Ravet",
description: "Luxury cab Ravet provides premium travel experience for corporate and special trips. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller Ravet",
description: "Tempo traveller Ravet offers group travel solutions for family and corporate trips. Customers can book vehicles for outstation journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent Ravet",
description: "Urbania on rent Ravet provides luxury group travel for large families and corporate trips. Customers can book premium vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Best Cab Service in Ravet for Airport Drop",
description: "Best cab service in Ravet for airport drop offers reliable transfer for passengers. Customers can book cabs for timely airport travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Affordable Cab Service Ravet for Outstation",
description: "Affordable cab service Ravet for outstation provides cost-effective travel solutions. Customers can book cabs for long-distance journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Ravet Cab Service for Family Trip",
description: "Ravet cab service for family trip offers comfortable travel for vacations and outings. Customers can book spacious vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with family trip cab services."
},
{
name: "Reliable Taxi Service Ravet Pune",
description: "Reliable taxi service Ravet Pune provides dependable transportation for customers. Users can book taxis for daily and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Cab Service in Ravet","Ravet Cab Service"],
["Taxi Service in Ravet","Ravet Taxi Service"],
["Cab Booking Ravet","Taxi Booking Ravet"],
["Cab Near Ravet","Taxi Near Ravet"],
["Best Cab Service in Ravet","Cheap Cab Service Ravet"],
["Affordable Cab Service Ravet","Ravet Cab Hire"],
["Ravet Taxi Hire","Ravet Cab for Airport"],
["Ravet Airport Cab Service","Ravet Cab for Outstation"],
["Cab Service Ravet Pune","Taxi Service Ravet Pune"],
["Cab Booking Ravet Pune","Innova Cab on Rent in Ravet"],
["Innova Crysta Cab Ravet","Ertiga Cab Ravet"],
["Dzire Cab Ravet","Sedan Cab on Rent Ravet"],
["Luxury Cab Ravet","Tempo Traveller Ravet"],
["Urbania on Rent Ravet","Ravet Cab Service for Family Trip"]
],



whychoose: [
  {
    WhyChooseheading: "Local Expertise in Ravet Area",
    WhyChoosedescription: "SRS Cab Service provides reliable cab service in Ravet with drivers familiar with local routes, Kiwale, Nigdi, Akurdi, and nearby PCMC areas."
  },
  {
    WhyChooseheading: "Affordable Cab Service in Ravet",
    WhyChoosedescription: "We offer budget-friendly cab services in Ravet with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Ravet, making it convenient for daily travel, office commutes, highway travel, and airport transfers."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable ride within Ravet and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for all travel needs."
  },
  {
    WhyChooseheading: "Quick Pickup & Doorstep Service",
    WhyChoosedescription: "We provide fast pickup from homes, societies, commercial areas, and highway points across Ravet and nearby locations."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe driving, polite behavior, and reliable service for every ride."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Ravet",
    WhyChoosedescription: "SRS Cab Service is trusted by residents in Ravet for punctual service, affordable pricing, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Ravet?", answer: "Yes, SRS Cab Service offers reliable cab services in Ravet for local and outstation travel." },
  { question: "Is cab service available 24 hours in Ravet?", answer: "Yes, our cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Ravet?", answer: "Yes, we provide Pune Airport pickup and drop services from Ravet." },
  { question: "Which areas do you cover near Ravet?", answer: "We cover Kiwale, Nigdi, Akurdi, Punawale, and nearby PCMC areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book cab online in Ravet?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide one-way and outstation cab?", answer: "Yes, we provide one-way and outstation cab services from Ravet." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked cab from Ravet to airport. Very quick pickup and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Ravet. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];





















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Ravet Cab Service",
  "description": "Reliable cab service in Ravet, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Ertiga, sedan, tempo traveller, Urbania, and luxury cab options for family trips and airport drops.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ravet",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "412101",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6510",
    "longitude": "73.7450"
  },
  "url": "https://www.srscabservice.com/ravet-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Ravet, Pune"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Cab Service in Ravet | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Ravet, Pune with SRS Cab. Local rides, airport transfers, outstation trips, and family travel options available 24/7. Innova, Ertiga, sedan, tempo traveller, Urbania, and luxury cab services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinravet;